// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{font-size:16px !important}.FeedbackModal-cls1___74df88421c1960744ce{/*!*/}.FeedbackModal-cls2___58ea5b1c54d01b9cb8b{font-family:\"Roboto\",Helvetica,Arial,sans-serif;font-family:var(--type-font-family-sans-serif, \"Roboto\"),Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;font-size:24px;line-height:30px;text-align:center;margin:0;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1___74df88421c1960744ce",
	"cls2": "FeedbackModal-cls2___58ea5b1c54d01b9cb8b FeedbackModal-cls1___74df88421c1960744ce"
};
export default ___CSS_LOADER_EXPORT___;
